"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Slider = _interopRequireDefault(require("../../Slider"));

var _Error = _interopRequireDefault(require("../Error"));

var _AmountInput = _interopRequireDefault(require("./AmountInput"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 40px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 15px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = _styledComponents.default.div(_templateObject());

var SliderWrapper = _styledComponents.default.div(_templateObject2());

var SliderInput = function SliderInput(_ref) {
  var color = _ref.color,
      disabled = _ref.disabled,
      errorText = _ref.errorText,
      id = _ref.id,
      instruction = _ref.instruction,
      max = _ref.max,
      min = _ref.min,
      onChange = _ref.onChange,
      sliderLabel = _ref.sliderLabel,
      step = _ref.step,
      value = _ref.value,
      fsMask = _ref.fsMask,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["color", "disabled", "errorText", "id", "instruction", "max", "min", "onChange", "sliderLabel", "step", "value", "fsMask"]);
  var stepOrDefault = (max - min) % step === 0 ? step : 1;
  /* This id is used to link the error message to AmountInput with `aria-describedby` for assistive technology users */

  var sliderInputErrorId = errorText ? "".concat(id, "-slider-input-error") : null;

  var amountInputProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    color: color,
    disabled: disabled,
    id: id,
    instruction: instruction,
    onChange: onChange,
    sliderInputErrorId: sliderInputErrorId,
    value: value,
    fsMask: fsMask
  });

  var sliderInputProps = {
    disabled: disabled,
    id: "".concat(id, "-slider"),
    min: min,
    max: max,
    onChange: onChange,
    sliderLabel: sliderLabel,
    step: stepOrDefault,
    trackColor: color,
    value: value
  };
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_AmountInput.default, amountInputProps), /*#__PURE__*/_react.default.createElement(SliderWrapper, null, /*#__PURE__*/_react.default.createElement(_Slider.default, sliderInputProps)), errorText && /*#__PURE__*/_react.default.createElement(_Error.default, {
    display: "block",
    id: sliderInputErrorId
  }, errorText));
};

SliderInput.propTypes = {
  /** Custom color for AmountInput text and the Slider  */
  color: _propTypes.default.string,

  /** Whether or not to disable both the amount and range inputs */
  disabled: _propTypes.default.bool,

  /** Error message text */
  errorText: _propTypes.default.string,

  /** The id for the amount input */
  id: _propTypes.default.string.isRequired,

  /** A string of informational text that appears below the amount input */
  instruction: _propTypes.default.string,

  /** The maximum value of the slider */
  max: _propTypes.default.number.isRequired,

  /** The minimum value of the slider */
  min: _propTypes.default.number.isRequired,

  /** onChange will be triggered while the value of Slider changing. */
  onChange: _propTypes.default.func.isRequired,

  /** Custom label text for the slider. Label text is visually hidden. */
  sliderLabel: _propTypes.default.string,

  /** Value to be added or subtracted on each step the slider makes. Must be greater than zero, and max - min should be evenly divisible by the step value. */
  step: _propTypes.default.number,

  /** Value for the amount and range inputs  */
  value: _propTypes.default.number,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
SliderInput.defaultProps = {
  color: '',
  disabled: false,
  errorText: '',
  instruction: '',
  sliderLabel: 'Select an amount',
  step: 100,
  value: undefined,
  fsMask: true
};
var _default = SliderInput;
exports.default = _default;